__webpack_require__.p = "/mi-assets/mi-static/mi-awp-renderer/web-rel-26.8.1-9496b88-13980/_next/";